import { render } from "./SearchAlgoliaDesktop.vue?vue&type=template&id=da893960"
import script from "./SearchAlgoliaDesktop.vue?vue&type=script&lang=js"
export * from "./SearchAlgoliaDesktop.vue?vue&type=script&lang=js"

import "./SearchAlgoliaDesktop.vue?vue&type=style&index=0&id=da893960&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__